export enum CDM_PATH {
    OVERVIEW = '/contacts',
    NEW_CONTACT_TYPE_SELECTOR = '/new-contact-selector',
    SIGN_CONTACT_CONFIRMATION = '/confirmation/sign/:signId',
}

export enum CDM_ABSOLUTE_PATH {
    OVERVIEW = '#/settings/contacts',
    NEW_CONTACT_TYPE_SELECTOR = '#/settings/contacts/edit/new-contact-selector',
    NEW_CONTACT = '#/settings/contacts/edit/:contactType/new',
    EDIT_CONTACT = '#/settings/contacts/edit/:contactType/:id/edit',
}
